import React, { useState, useEffect, useRef, useMemo, memo, StrictMode, useCallback } from 'react';
import { Navbar, Container, Dropdown, Nav } from 'react-bootstrap';
import { Link, BrowserRouter, useNavigate } from 'react-router-dom';
import { useAuthentication, useApp } from '../../Hooks';
import { SettingsButton } from './SettingsButton';
import { SupportButton } from './SupportButton';
import { SwitchCompanyButton } from './SwitchCompanyButton';
import { ShortcutButton } from '../ShortcutButton/ShortcutButton';
import { DocumentoPreview } from '../DocumentoPreview/DocumentoPreview';
import ToolTip from '../ToolTip/Tooltip';
import { ConfiguracionInicialNavbarItem } from '@configuracionInicial/Components/ConfiguracionInicialNavbarItem';
import './FormalizarTrialButton.css';

const Dp = Dropdown;
export const NavBar = memo(() => {
  const [usaNomina, setUsaNomnina] = useState('');
  const [esPrueba, setEsPrueba] = useState(false);
  const [companiasPermitidas, setCompaniasPermitidas] = useState(0);
  
  const {usuario, TIENE_PERMISO} = useAuthentication();
  const {configuration} = useApp();
  const navigate = useNavigate();
  function formalizar(){
    window.location.href = '/Public/citrus_formalizar_pago_linea.aspx?Esc=1';
  }

  useEffect(() => {
      setCompaniasPermitidas(usuario?.CompaniasPermitidas?.length)
      setEsPrueba(usuario?.Compania?.Configuracion?.EsCompaniaPrueba)
      setUsaNomnina(usuario?.Compania?.UsaNomina)
  }, [usuario]);

  const openInNewTab = useCallback((url) => {
    const win = window.open(url, "_blank", "noopener,noreferrer");
    win.focus();
  }, []);
  useEffect(() => {
    document.body.classList.add("sidebar-mini");
    document.body.classList.add("off-canvas-sidebar");
    document.body.classList.add("body");
    document.body.style.setProperty('font-family', configuration?.Vendor === 'claro' ? 'AMX' : 'Roboto', 'important');
  }, []);
  
  return (
    <React.Fragment>
      <Container fluid className="d-flex justify-content-end">
        {usuario !== null && (
          <>
            {esPrueba && configuration?.Vendor !== "claro" && (
              <Dp
                as={Nav.Item}
                style={{
                  position: 'absolute',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  marginRight: '20px'
                }}
              >
                <Dp.Toggle
                  as={Nav.Link}
                  id="dropdown-formalizar"
                  className="formalizar-trial-link"
                  onClick={(e) => {
                    e.preventDefault();
                    formalizar();
                  }}
                >
                  <ToolTip placement="left" message="Formalizar mi cuenta">
                    <span className="formalizar-trial-button">
                      <span className="formalizar-trial-button__logo" aria-hidden="true">
                        <img src="/img/public/citrus_logo.png" alt="" />
                      </span>
                      <span className="formalizar-trial-button__label">
                        Formalizar mi cuenta
                      </span>
                      <span className="formalizar-trial-button__arrow" aria-hidden="true">
                        <svg viewBox="0 0 24 24" focusable="false">
                          <path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z" />
                        </svg>
                      </span>
                    </span>
                  </ToolTip>
                </Dp.Toggle>
              </Dp>
            )}
            <ShortcutButton />
            <ConfiguracionInicialNavbarItem />
            {usaNomina && (
              <Dp as={Nav.Item}>
                <Dp.Toggle
                  as={Nav.Link}
                  id="dropdown-mis-solicitudes"
                  className="buttonHover"
                  onClick={(e) => {
                    e.preventDefault();
                    openInNewTab("/Nomina/mis_solicitudes.aspx");
                  }}
                >
                  <ToolTip placement="left" message="Mis Solictudes">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="34"
                      fill="#77777A"
                      height="34"
                      viewBox="0 -960 960 960"
                    >
                      <path d="M307.72-293.693q11.588 0 19.819-8.258 8.231-8.257 8.231-19.846 0-11.588-8.258-19.819-8.258-8.23-19.846-8.23-11.588 0-19.819 8.257-8.231 8.258-8.231 19.846 0 11.589 8.258 19.819 8.258 8.231 19.846 8.231Zm0-158.23q11.588 0 19.819-8.258t8.231-19.846q0-11.588-8.258-19.819t-19.846-8.231q-11.588 0-19.819 8.258t-8.231 19.846q0 11.588 8.258 19.819t19.846 8.231Zm0-158.231q11.588 0 19.819-8.257 8.231-8.258 8.231-19.846 0-11.589-8.258-19.819-8.258-8.231-19.846-8.231-11.588 0-19.819 8.258-8.231 8.257-8.231 19.846 0 11.588 8.258 19.819 8.258 8.23 19.846 8.23Zm130.434 311.076h230.538v-45.383H438.154v45.383Zm0-158.23h230.538v-45.384H438.154v45.384Zm0-158.231h230.538v-45.383H438.154v45.383Zm-240.46 475.538q-23.529 0-40.611-17.082-17.082-17.082-17.082-40.611v-564.612q0-23.529 17.082-40.611 17.082-17.082 40.611-17.082h564.612q23.529 0 40.611 17.082 17.082 17.082 17.082 40.611v564.612q0 23.529-17.082 40.611-17.082 17.082-40.611 17.082H197.694Zm0-45.384h564.612q4.616 0 8.463-3.846 3.846-3.847 3.846-8.463v-564.612q0-4.616-3.846-8.463-3.847-3.846-8.463-3.846H197.694q-4.616 0-8.463 3.846-3.846 3.847-3.846 8.463v564.612q0 4.616 3.846 8.463 3.847 3.846 8.463 3.846Zm-12.309-589.23V-185.385-774.615Z" />
                    </svg>
                  </ToolTip>
                </Dp.Toggle>
              </Dp>
            )}
            {TIENE_PERMISO("Citrus.Seguridad.CitrusGPT.Consultar") && (
              <Dp as={Nav.Item}>
                <Dp.Toggle
                  as={Nav.Link}
                  id="dropdown-chat-bot"
                  className="buttonHover"
                  aria-label="Chat bot"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/App/Seguridad/CitrusGPT");
                  }}
                >
                  <ToolTip placement="left" message="Chat bot">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 -960 960 960"
                      fill="#77777A"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <path d="M160-120v-200q0-33 23.5-56.5T240-400h480q33 0 56.5 23.5T800-320v200H160Zm200-320q-83 0-141.5-58.5T160-640q0-83 58.5-141.5T360-840h240q83 0 141.5 58.5T800-640q0 83-58.5 141.5T600-440H360ZM240-200h480v-120H240v120Zm120-320h240q50 0 85-35t35-85q0-50-35-85t-85-35H360q-50 0-85 35t-35 85q0 50 35 85t85 35Zm28.5-91.5Q400-623 400-640t-11.5-28.5Q377-680 360-680t-28.5 11.5Q320-657 320-640t11.5 28.5Q343-600 360-600t28.5-11.5Zm240 0Q640-623 640-640t-11.5-28.5Q617-680 600-680t-28.5 11.5Q560-657 560-640t11.5 28.5Q583-600 600-600t28.5-11.5ZM480-200Zm0-440Z" />
                    </svg>
                  </ToolTip>
                </Dp.Toggle>
              </Dp>
            )}
            <Dp as={Nav.Item}>
              <Dp.Toggle
                as={Nav.Link}
                id="dropdown-centro-ayuda"
                className="buttonHover"
                aria-label="Centro de Ayuda"
              >
                <ToolTip placement="left" message="Centro de Ayuda">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 -960 960 960"
                    fill="#77777A"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path d="M504-257.03q11-11.03 11-27T503.97-311q-11.03-11-27-11T450-310.97q-11 11.03-11 27T450.03-257q11.03 11 27 11T504-257.03ZM444-394h57q0-31 10-50.5t34.72-44.22Q579-522 592-547.5t13-53.5q0-53-34-84t-91.52-31q-51.87 0-88.17 24.5Q355-667 338-624l53 22q14-28 36.2-42.5Q449.4-659 479-659q32 0 50.5 16t18.5 44.1q0 19.9-11 38.4T500-517q-37 35-46.5 60t-9.5 63ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Z" />
                  </svg>
                </ToolTip>
              </Dp.Toggle>
              <Dp.Menu align="end" aria-labelledby="dropdown-centro-ayuda">
                <Dp.Item
                  href="https://citrus.com.do/docs/erp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 -960 960 960"
                    fill="#2f2f2f"
                    style={{ marginRight: "8px" }}
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path d="M180-180v-600 224-33 409Zm97-270h253.7q2.3-16 6.3-31t12-29H277v60Zm0 171h198q17-14 36.5-23.5T552-319v-20H277v60Zm0-342h406v-60H277v60Zm-97 501q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v345q0-37-16.5-68.5T780-556v-224H180v600h248v60H180Zm437.5-248.5Q590-396 590-435t27.5-66.5Q645-529 684-529t66.5 27.5Q778-474 778-435t-27.5 66.5Q723-341 684-341t-66.5-27.5ZM488-120v-51q0-26 11-44.5t31-28.5q37-19 75-28t79-9q41 0 79 8.5t75 28.5q20 9 31 28t11 45v51H488Z" />
                  </svg>
                  Documentación
                </Dp.Item>
                <Dp.Item
                  href="https://youtube.com/@citrustechnologygroup9426?si=YzwbYj6s6jfAOl0r"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 196 144"
                    fill="#2f2f2f"
                    style={{ marginRight: "8px" }}
                    aria-hidden="true"
                    focusable="false"
                  >
                    <g>
                      <path d="M157.0235,0H38.9763C17.4843,0,0,17.5393,0,39.0977v65.8048C0,126.4609,17.4843,144,38.9763,144h118.0472C178.5155,144,196,126.4609,196,104.9025V39.0977C196,17.5393,178.5155,0,157.0235,0z M188,104.9025C188,122.0489,174.1035,136,157.0235,136H38.9763C21.8963,136,8,122.0489,8,104.9025V39.0977C8,21.9513,21.8963,8,38.9763,8h118.0472C174.1035,8,188,21.9513,188,39.0977V104.9025z" />
                      <path d="M133.4415,70.5529l-55.42-32.4612c-1.2304-.7204-2.7655-.7324-4.01-.0192C72.7675,38.7853,72,40.1093,72,41.5429v64.9144c0,1.4336.7675,2.7576,2.0095,3.4704.6172.3536,1.3048.5296,1.9905.5296.6991,0,1.3963-.1836,2.0215-.5488l55.42-32.4532c1.2244-.7168,1.9785-2.0313,1.9785-3.4513C135.42,72.584,134.668,71.2697,133.4415,70.5529zM80,99.4785V48.5217l43.504,25.4823L80,99.4785z" />
                    </g>
                  </svg>
                  Videos Tutoriales
                </Dp.Item>
              </Dp.Menu>
            </Dp>
            {configuration?.Vendor !== "claro" && (
              <Dp as={Nav.Item}>
                <Dp.Toggle
                  as={Nav.Link}
                  id="dropdown-soporte-whatsapp"
                  className="buttonHover"
                  onClick={(e) => {
                    e.preventDefault();
                    openInNewTab(
                      "https://api.whatsapp.com/send?phone=18095488274"
                    );
                  }}
                >
                  <ToolTip placement="left" message="Soporte Whatsapp">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      fill="#77777A"
                      height="28"
                      viewBox="0 0 24 24"
                    >
                      <g id="whatsapp">
                        <g data-name="<Group>" id="_Group_">
                          <path
                            d="M12,.5A11.5,11.5,0,0,0,2.46,18.42L.5,23.5l5.23-1.87A11.5,11.5,0,1,0,12,.5Z"
                            data-name="<Path>"
                            id="_Path_"
                            style={{
                              fill: "none",
                              stroke: "#77777A",
                              strokeLinecap: "round",
                              strokeLinejoin: "round",
                            }}
                          />
                          <path
                            d="M9.5,14.5c1.3,1.3,4.17,3,5.5,3a2.53,2.53,0,0,0,2.5-2v-1s-1.23-.6-2-1-2,1-2,1A6.52,6.52,0,0,1,11,13a6.52,6.52,0,0,1-1.5-2.5s1.4-1.23,1-2-1-2-1-2h-1A2.53,2.53,0,0,0,6.5,9C6.5,10.33,8.2,13.2,9.5,14.5Z"
                            data-name="<Path>"
                            id="_Path_2"
                            style={{
                              fill: "none",
                              stroke: "#77777A",
                              strokeLinecap: "round",
                              strokeLinejoin: "round",
                            }}
                          />
                        </g>
                      </g>
                    </svg>
                  </ToolTip>
                </Dp.Toggle>
              </Dp>
            )}
              <SupportButton />
              {companiasPermitidas > 1 && (
              <SwitchCompanyButton/>
            )}
            <SettingsButton usuario={usuario}/>
            <DocumentoPreview />
          </>
        )}
      </Container>
    </React.Fragment>
  );
});
